import { css } from '@emotion/css'

export const stackWrapperStyle = css`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  min-height: 220px;
`

export const cardContainerStyle = css`
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  transition: all 0.3s ease;
`

export const cardBaseStyle = css`
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  box-sizing: border-box;
  width: 100%;
  transition: all 0.3s ease;
  border: 1px solid #e7e7ee;
`

export const getStackCardStyle = (offset, total, isTop, isCompleted) => {
  const topOffset = -15 * offset
  const widthReduction = 20 * offset

  return css`
    position: relative;
    top: ${topOffset}px;
    width: calc(100% - ${widthReduction}px);
    box-shadow: ${isTop && !isCompleted ? '0 8px 24px rgba(37, 99, 235, 0.12)' : '0 4px 12px rgba(0, 0, 0, 0.08)'};
    z-index: ${10 - offset};
    opacity: ${isTop ? 1 : 0.9};
    transform: translateY(${offset * 10}px);
    border-color: ${isCompleted ? '#e0e0e0' : '#e7e7ee'};
    background-color: ${isCompleted ? '#f9f9f9' : '#fff'};
  `
}

export const headerStyle = css`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
`

export const numberCircleStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #0246f8;
  color: #fff;
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  flex-shrink: 0;
`

export const completedNumberCircleStyle = css`
  ${numberCircleStyle};
  background: #e0e0e0;
  color: #757575;
`

export const titleStyle = css`
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  font-size: 20px;
  color: #1b1b26;
`

export const descStyle = css`
  font-family: Plus Jakarta Sans;
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  color: #76767d;
`

export const seeAllStepsButtonSx = {
  borderRadius: '12px',
  fontFamily: 'Plus Jakarta Sans',
  fontWeight: 400,
  fontSize: '16px',
  width: 'auto',
  padding: '6px 16px',
  backgroundColor: '#0246F8',
  color: '#fff',
  textTransform: 'none',
  '&:hover': { backgroundColor: '#1d4ed8' },
  '&.Mui-disabled': {
    backgroundColor: '#bdbdbd',
    color: '#757575'
  }
}

export const actionsContainerStyle = css`
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  padding-top: 8px;
  align-items: center;
`

export const cardGradientStyle = css`
  position: absolute;
  width: 85px;
  height: 90px;
  left: 15px;
  top: 55px;
  background: #0246f8;
  filter: blur(100px);
`
